<template>
  <el-select ref="select" v-model="selectedValue" placeholder="请选择父路由">
    <el-option :label="selectedLabel" :value="selectedValue">
      <el-tree ref="tree" highlight-current
               :data="data" :props="props" :node-key="props.key"
               @node-click="handleTreeNodeClick">
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "TreeSelect",
  props: {
    value: {}, // 默认的v-model的prop
    data: Array,
    props: {
      type: Object,
      default: () => {
        return {
          key: "id",
          label: "label",
          children: "children"
        }
      }
    },
    // 自定义v-model的prop和event，避免冲突，默认为："value"和"input"。
    /*model: {
      prop: "xxx",
      event: "xxx"
    }*/
  },
  data() {
    return {
      selectedLabel: "",
      selectedValue: ""
    }
  },
  mounted() {
    // 模型有初始值时，初始化选择器状态
    if (this.value !== null && this.value !== undefined) {
      this.selectedValue = this.value
      this.selectedLabel = this.$refs.tree.getNode(this.selectedValue).data[this.props.label]
      this.$refs.tree.setCurrentKey(this.selectedValue)
    }
  },
  methods: {
    handleTreeNodeClick(data) {
      this.selectedLabel = data[this.props.label]
      this.selectedValue = data[this.props.key]
      // input是内置的模型绑定事件
      this.$emit("input", this.selectedValue)

      this.$refs.select.blur();
    }
  }
}
</script>

<style lang="scss" scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 5px;
  background-color: #f3f3f3;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #1890ff;
}

.el-select-dropdown__item.selected {
  font-weight: normal;
}
</style>